import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';

import { useSearchHandler } from 'decorators/withSearchHandler';

import { SelectOptionsGroup } from 'components/core/SelectOptionsGroup';
import { HH, H2 } from 'components/core/Headline';
import { SearchBox } from 'components/search/SearchBox';
import { StickySearchBar } from 'components/landing/StickySearchBar';

const options = [
	{
		display: 'Self-storage',
		value: '',
	},
	{
		display: 'Car storage',
		value: 'car',
	},
	{
		display: 'RV storage',
		value: 'rv',
	},
	{
		display: 'Boat storage',
		value: 'boat',
	},
];

export function HomePageHero() {
	const [searchType, setSearchType] = useState('');
	const [additionalSearchParams, setAdditionalSearchParams] = useState({});

	const handleSelectProduct = useCallback((selectedType) => {
		if (['car', 'rv', 'boat'].includes(selectedType)) {
			setSearchType('vehicle');
			setAdditionalSearchParams((prev) => ({
				...prev,
				vehicle: selectedType,
			}));
		} else {
			setSearchType(selectedType);
			setAdditionalSearchParams((prev) => omit(prev, ['vehicle']));
		}
	}, []);

	const { handleSearch } = useSearchHandler({
		searchType,
		additionalSearchParams,
	});
	return (
		<div className="hero">
			<div className="section-content">
				<HH
					rounded
					size="extra-large"
				>
					Find your stuff a home.
				</HH>
				<H2 size="medium">
					<strong>
						Find and reserve storage in minutes with SpareFoot.
					</strong>
				</H2>
				<div
					className="search-container"
					id="home-page-sticky-search"
				>
					<div className="select-container">
						<div className="select-label">
							<strong>Show me:</strong>
						</div>
						<SelectOptionsGroup
							id="search-type"
							options={options}
							onChange={handleSelectProduct}
							selected=""
							name="search-type"
							groupType="single"
						/>
					</div>
					<SearchBox
						handleSearch={handleSearch}
						id="home-hero-search"
						darkButton
					/>
				</div>
			</div>
			<StickySearchBar
				triggerId="home-page-sticky-search"
				handleSearch={handleSearch}
			/>
		</div>
	);
}

export default HomePageHero;
